<section class="py-16 " [style.background-color]="this.loadeddata?.SeconndaryColor">
  <div class="text-center mt-20 mb-6">
    <h2 class="justify-center text-4xl md:text-7xl font-bold">20% Off All Fan Plans Just for Faculty and Staff.</h2>
    <p class="text-4xl text-black font-bold mt-4">On the T-Mobile 5G Network.</p>

  </div>

  <div class="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-8xl mx-auto flex flex-col p-6">
    <div *ngFor="let plan of plans" class="bg-white p-6 rounded-2xl shadow-md flex flex-col justify-between border"
      (click)="selectPlan(plan.name,'cardhighlighted')" [ngStyle]="plan.name === selectedPlanName
    ? {
        'border': '4px solid ' + loadeddata?.PrimaryColor,
        'box-shadow': '0 0 20px ' + loadeddata?.PrimaryColor
      }
    : {
        'border': '1px solid ' + loadeddata?.SecondaryColor,
        'box-shadow': 'none'
      }">

      <div>
        <div class="mt-2 mb-6">
          <span class="text-lg md:text-xl font-bold px-3 py-1 rounded-full uppercase"
            [ngStyle]="{'background-color':loadeddata?.SeconndaryColor,  color: loadeddata?.PrimaryColor }">
            {{ plan.name }}
          </span>
        </div>

        <h2 class="text-4xl font-bold" [ngStyle]="{ color: loadeddata?.PrimaryColor }">
          <span class='text-2xl md:text-3xl font-normal text-gray-300 line-through'>${{plan.price}}</span>${{
          plan.discountedPrice }}
          <span class="text-3xl font-bold" [ngStyle]="{ color: loadeddata?.PrimaryColor }">/mo</span>
        </h2>


        <p class="mt-2 text-lg text-black lg:text-black text-black  pb-5">{{ plan.description }}</p>
        <p class="six-lines mr-4 text-lg text-gray-600">{{ plan.subText }}</p>

        <div class="mt-2 bg-gray-100 ">
          <button class="btn btn-primary w-full rounded-md font-bold text-lg"
            (click)="selectPlan(plan.url,'buttonclicked')">Select {{plan.name}}</button>
        </div><br>

        <hr class="border-gray-200">

        <ul class="mt-6 list-disc marker:text-black text-lg md:text-sm">
          <li *ngFor="let feature of plan.features" class="ml-4 mt-2 items-start gap-2">
            <div>
              <p class="text-lg md:text-sm text-gray-800" [innerHTML]="feature.title"></p>
              <p *ngIf="feature.description" class="text-lg md:text-sm text-gray-500">{{ feature.description }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="mt-4 ">
        <div tabindex="0" class="md:hidden collapse collapse-plus border-0 border-none bg-base-100 w-full">
          <input type="checkbox" (click)="selectData(plan.id); $event.stopPropagation()" />
          <div class="collapse-title border-0 font-medium hover:underline"
            [ngStyle]="{ color: loadeddata?.PrimaryColor }">
            See Broadband Facts
          </div>
          <div class="collapse-content ">
            <div *ngIf="plan.id === selectedData"
              class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 max-w-xl mx-auto">
              <div class="w-full border-4 border-black shadow-lg overflow-hidden rounded-xl bg-white">

                <!-- Header -->
                <div class="text-white font-bold px-4 py-4">
                  <p class="text-black text-3xl font-bold">Broadband Facts</p>
                </div>

                <!-- Content -->
                <div id="broadbandCard" class="p-4 space-y-4 text-lg md:text-sm break-words lg:text-black">

                  <!-- Broadband Title -->
                  <div class="border-t-4 border-black pt-2 text-xs">
                    <p class="font-bold text-xs">{{this.loadeddata['Name']}}</p>
                    <p class="text-xs">{{ broadbandLabelData[0]?.service_plan_name }}</p>
                    <p class="lg:text-black text-black text-xs">Mobile Broadband Consumer Disclosure</p>
                  </div>

                  <!-- Monthly Price -->
                  <div class="border-t-8 border-black pt-2 text-xs">
                    <p class="font-bold text-xs">Monthly Price
                      <span class="float-right text-xs">${{ broadbandLabelData[0]?.monthly_price }}</span>
                    </p>
                    <div class="border-t-4 border-black pt-2 text-xs">
                      <p>This plan is not an introductory rate</p>
                      <p>This monthly price does not require a contract</p>
                    </div>
                  </div>

                  <!-- Charges & Terms -->
                  <div class="border-t-4 border-black pt-2">
                    <p class="font-bold text-xs">Additional Charges & Terms</p>
                    <ul class="list-none space-y-1">
                      <li class="px-2 text-xs">Provider Monthly Fees <span class="float-right">{{
                          broadbandLabelData[0]?.monthly_provider_fee }}</span></li>
                      <li class="px-2 text-xs">One-time Purchase Fees <span class="float-right">{{
                          broadbandLabelData[0]?.single_purchase_fee }}</span></li>
                      <li class="px-2 text-xs">Early Termination Fee <span class="float-right">{{
                          broadbandLabelData[0]?.early_termination_fee }}</span></li>
                      <li class="px-2 text-xs">Government Taxes <span class="float-right">{{ broadbandLabelData[0]?.tax
                          }}</span></li>
                    </ul>
                  </div>

                  <!-- Discounts -->
                  <div class="border-t-4 border-black pt-2 text-xs">
                    <p class="font-bold">Discounts & Bundles</p>
                    <p>{{ broadbandLabelData[0]?.governmentTaxes }}</p>
                  </div>

                  <!-- Speeds -->
                  <div class="border-t-4 border-black pt-2 text-xs">
                    <p class="font-bold">Speeds Provided with Plan</p>
                    <p class="px-2">Download: <span class="float-right">{{ broadbandLabelData[0]?.typical_download_speed
                        }} Mbps</span></p>
                    <p class="px-2">Upload: <span class="float-right">{{ broadbandLabelData[0]?.typical_upload_speed }}
                        Mbps</span></p>
                    <p class="px-2">Latency: <span class="float-right">{{ broadbandLabelData[0]?.typical_latency_speed
                        }} ms</span></p>
                  </div>

                  <!-- Data -->
                  <div class="border-t border-black pt-2 text-xs">
                    <p class="font-bold">Data Included with Monthly <br> Price
                      <span class="float-right"> {{ broadbandLabelData[0]?.monthly_data_allow }} GB</span>
                    </p>
                    <p class="px-2 pt-1">Additional Usage
                      <span class="float-right">${{ broadbandLabelData[0]?.over_usage_data_price }}</span>
                    </p>
                  </div>

                  <!-- Network Management -->
                  <div class="border-t-4 border-black pt-2 text-xs">
                    <p class="font-bold">Network Management Policy</p>
                    <a class="px-2 break-all block" href="{{ broadbandLabelData[0]?.network_management_policy_url }}">{{
                      broadbandLabelData[0]?.network_management_policy_url }}</a>
                    <p class="font-bold mt-2">Privacy Policy</p>
                    <a class="px-2 break-all block" href="{{ broadbandLabelData[0]?.privacy_policy_url }}">{{
                      broadbandLabelData[0]?.privacy_policy_url }}</a>
                  </div>

                  <!-- Support -->
                  <div class="border-t-8 border-black pt-2 text-xs">
                    <p class="font-bold">Customer Support</p>
                    <p class="px-2">Phone: <a href="tel: {{ broadbandLabelData[0]?.customer_support_phone }}">{{
                        broadbandLabelData[0]?.customer_support_phone }}</a></p>
                    <p class="font-bold mt-2">Website</p>
                    <a class="px-2 break-all block" href="{{ broadbandLabelData[0]?.customer_support_web }}">{{
                      broadbandLabelData[0]?.customer_support_web }}</a>
                  </div>

                  <!-- Footer -->
                  <div class="border-t-4 border-black pt-2 text-xs">
                    <p>{{ broadbandLabelData[0]?.code }}</p>
                    <p class="float-right">fcc.gov/consumer</p>
                    <p class="pt-6">Unique Plan Identifier: {{ broadbandLabelData[0]?.unique_plan_id }}</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden md:block">
          <a (click)=" selectData(plan.id) ;" class="font-medium hover:underline"
            [ngStyle]="{color: loadeddata?.PrimaryColor }">
            See Broadband Facts {{ plan.id === selectedData ? '−' : '+' }}
          </a>
        </div>

      </div>

    </div>
  </div>

  <div class="px-4 md:px-6">

    <!-- Responsive Plan Cards -->

    <div *ngIf="selectedData"
      class="hidden md:block grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 gap-4 max-w-lg mx-auto px-4 py-8 ">
      <div class="w-full border-4 border-black shadow-lg overflow-hidden rounded-xl bg-white">

        <!-- Header -->
        <div class="text-white font-bold px-4 py-4">
          <p class="text-black text-3xl font-bold">Broadband Facts</p>
        </div>

        <!-- Content -->
        <div id="broadbandCard" class="p-4 space-y-4 text-lg md:text-sm break-words lg:text-black">

          <!-- Broadband Title -->
          <div class="border-t-4 border-black pt-2">
            <p class="font-bold text-lg">{{this.loadeddata['Name']}}</p>
            <p>{{ broadbandLabelData[0]?.service_plan_name }}</p>
            <p class="lg:text-black text-black">Mobile Broadband Consumer Disclosure</p>
          </div>

          <!-- Monthly Price -->
          <div class="border-t-8 border-black pt-2">
            <p class="font-bold text-lg">Monthly Price
              <span class="float-right">${{ broadbandLabelData[0]?.monthly_price }}</span>
            </p>
            <div class="border-t-4 border-black pt-2">
              <p>This plan is not an introductory rate</p>
              <p>This monthly price does not require a contract</p>
            </div>
          </div>

          <!-- Charges & Terms -->
          <div class="border-t-4 border-black pt-2">
            <p class="font-bold">Additional Charges & Terms</p>
            <ul class="list-none space-y-1">
              <li class="px-2">Provider Monthly Fees <span class="float-right">{{
                  broadbandLabelData[0]?.monthly_provider_fee }}</span></li>
              <li class="px-2">One-time Purchase Fees <span class="float-right">{{
                  broadbandLabelData[0]?.single_purchase_fee }}</span></li>
              <li class="px-2">Early Termination Fee <span class="float-right">{{
                  broadbandLabelData[0]?.early_termination_fee }}</span></li>
              <li class="px-2">Government Taxes <span class="float-right">{{ broadbandLabelData[0]?.tax }}</span></li>
            </ul>
          </div>

          <!-- Discounts -->
          <div class="border-t-4 border-black pt-2">
            <p class="font-bold">Discounts & Bundles</p>
            <p>{{ broadbandLabelData[0]?.governmentTaxes }}</p>
          </div>

          <!-- Speeds -->
          <div class="border-t-4 border-black pt-2">
            <p class="font-bold">Speeds Provided with Plan</p>
            <p class="px-2">Download: <span class="float-right">{{ broadbandLabelData[0]?.typical_download_speed }}
                Mbps</span></p>
            <p class="px-2">Upload: <span class="float-right">{{ broadbandLabelData[0]?.typical_upload_speed }}
                Mbps</span></p>
            <p class="px-2">Latency: <span class="float-right">{{ broadbandLabelData[0]?.typical_latency_speed }}
                ms</span></p>
          </div>

          <!-- Data -->
          <div class="border-t border-black pt-2">
            <p class="font-bold">Data Included with Monthly Price
              <span class="float-right">{{ broadbandLabelData[0]?.monthly_data_allow }} GB</span>
            </p>
            <p class="px-2 pt-1">Charges for Additional Data Usage
              <span class="float-right">${{ broadbandLabelData[0]?.over_usage_data_price }}</span>
            </p>
          </div>

          <!-- Network Management -->
          <div class="border-t-4 border-black pt-2">
            <p class="font-bold">Network Management Policy</p>
            <a class="px-2 break-all block" href="{{ broadbandLabelData[0]?.network_management_policy_url }}">{{
              broadbandLabelData[0]?.network_management_policy_url }}</a>
            <p class="font-bold mt-2">Privacy Policy</p>
            <a class="px-2 break-all block" href="{{ broadbandLabelData[0]?.privacy_policy_url }}">{{
              broadbandLabelData[0]?.privacy_policy_url }}</a>
          </div>

          <!-- Support -->
          <div class="border-t-8 border-black pt-2">
            <p class="font-bold">Customer Support</p>
            <p class="px-2">Phone: <a href="tel: {{ broadbandLabelData[0]?.customer_support_phone }}">{{
                broadbandLabelData[0]?.customer_support_phone }}</a></p>
            <p class="font-bold mt-2">Website</p>
            <a class="px-2 break-all block" href="{{ broadbandLabelData[0]?.customer_support_web }}">{{
              broadbandLabelData[0]?.customer_support_web }}</a>
          </div>

          <!-- Footer -->
          <div class="border-t-4 border-black pt-2 text-xs">
            <p>{{ broadbandLabelData[0]?.code }}</p>
            <p class="float-right">fcc.gov/consumer</p>
            <p class="pt-6">Unique Plan Identifier: {{ broadbandLabelData[0]?.unique_plan_id }}</p>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="px-6 pb-4">
    <p>*After using your plan's high-speed data, you'll stay connected at reduced speeds—up to 512 kbps for FACULTY
      UNLIMITED, supporting video/audio streaming, browsing, navigation, and email; and up to 256 kbps for FACULTY
      PREMIUM and FACULTY PLUS, supporting audio streaming, browsing, navigation, and email.</p>
  </div>

  <div class="text-center">
    <h1 class="text-4xl font-bold">All plans give back to your {{this.loadeddata['ShortNamePlural']}}.</h1>
    <div>
      <button
        class="btn btn-primary font-bold text-lg rounded-md my-8  md:px-6 pt-[.5rem] pb-[3.0rem] md:pt-[1rem] md:pb-[2.5rem]"
        (click)="trackevent('facultyplans.why')" routerLink="/{{this.tenantName}}/why">See how {{this.loadeddata['Name']}} Gives
        Back</button>
    </div>
  </div>
  <div class="text-center mt-5">
    <h1 class="text-md text-purple">* See our terms of service for details below</h1>
  </div>

</section>

<section class="husky-purple-bg py-4 px-4" id="ourPlans" #planssection
  [style.background-color]="this.loadeddata?.PrimaryColor">
  <div class="text-center">
    <img src="{{ tenant.getImg(tenant.MARK1) }}" class="object-cover m-auto"
      alt="Partner of {{ this.loadeddata?.CollegeName }}" title="Partner of {{ this.loadeddata?.CollegeName }}">
  </div>
</section>


<section class="bg-gray-50 pb-7 mt-24">
  <div class="text-center mx-auto">
    <h1 class="text-6xl pl-8 pr-8 font-bold perk-header">The Ultimate Phone Plan for
      {{ this.loadeddata?.ShortName === 'Bear' ? 'University' : this.loadeddata['CollegeNameAcronym']}} Faculty and Staff</h1>
    <h2 class="text-2xl pl-8 pr-8 mt-4">A mobile plan that celebrates your contribution to {{ this.loadeddata?.ShortName
      === 'Bear' ? 'the' : '' }}
      {{this.loadeddata?.ShortName}} {{ this.loadeddata?.ShortName === 'Bear' ? 'Community' : 'Nation' }}.</h2>

    <!-- Moblie View Perks-->
    <div class="block md:hidden bg-gray-50">
      <div #carousel class="flex overflow-x-auto space-x-4 pb-4 snap-x snap-mandatory">

        <div class="flex-shrink-0 w-screen items-center p-6 text-center snap-center">
          <div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
            [ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
            <img src="/assets/shared/perk2.png" class="object-cover">
          </div>
          <h3 class="perk-title">20% Off Fan Plans</h3>
        </div>

        <div class="flex-shrink-0 w-screen items-center p-6  text-center snap-center">
          <div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
            [ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
            <img src="/assets/shared/perk1.png" class="object-cover">
          </div>
          <h3 class="perk-title">7% <br class="hidden sm:inline"> Giveback and VIP <br class="hidden sm:inline"> perks
          </h3>
        </div>

        <div class="flex-shrink-0 w-screen items-center p-6 text-center snap-center">
          <div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
            [ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
            <img src="/assets/shared/perk4.png" class="object-cover">
          </div>
          <h3 class="perk-title">Powered by T-Mobile's <br class="hidden sm:inline"> 5G Network</h3>
        </div>
      </div>

      <!-- Dots  -->
      <div class="flex justify-center mt-4 space-x-2">
        <button (click)="scrollToCard(0)" [ngClass]="getDotClass(0)"></button>
        <button (click)="scrollToCard(1)" [ngClass]="getDotClass(1)"></button>
        <button (click)="scrollToCard(2)" [ngClass]="getDotClass(2)"></button>
      </div>
    </div>

    <!-- Desktop view perks-->
    <div class="mx-auto max-w-[75%]">
      <div class="hidden md:grid md:grid-cols-3">
        <div class="text-center m-6">
          <!-- <div class="icon-wrapper ">
				<span class="material-symbols-outlined perk-icon">receipt_long</span>
				</div> -->
          <div class="h-[120px] justify-center  mx-auto">
            <div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
              [ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
              <img src="/assets/shared/perk2.png" class="object-cover m-auto mb-4">
            </div>
          </div>
          <h3 class="perk-title"><span class="text-3xl">20% Off Fan Plans</span></h3>
        </div>

        <div class="text-center m-6">
          <!-- <div class="icon-wrapper ">
				<span class="material-symbols-outlined perk-icon">receipt_long</span>
				</div> -->
          <div class="h-[120px] justify-center  mx-auto">
            <div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
              [ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
              <img src="/assets/shared/perk1.png" class="object-cover mx-auto ">
            </div>
          </div>
          <h3 class="perk-title"><span class="text-3xl">7% Giveback and VIP Perks</span></h3>
        </div>

        <div class="text-center m-6">
          <!-- <div class="icon-wrapper ">
				<span class="material-symbols-outlined perk-icon">receipt_long</span>
				</div> -->
          <div class="h-[120px] justify-center  mx-auto">
            <div class="grid place-items-center w-28 h-28 rounded-full mx-auto"
              [ngStyle]="{'background-color': loadeddata?.SeconndaryColor }">
              <img src="/assets/shared/perk4.png" class="object-cover m-auto mb-4">
            </div>
          </div>
          <h3 class="perk-title"><span class="text-3xl">On the T-Mobile 5G Network</span></h3>
        </div>
      </div>
    </div>
  </div>
</section>


<app-giveaways></app-giveaways>


<div class="pt-16 pb-32 flex flex-col md:flex-row gap-8" [style.background-color]="this.loadeddata?.PrimaryColor">
  <div class="flex justify-center md:w-1/2 lg:w-1/2 md:pl-12 lg:pl-12">
    <h2 class="text-6xl text-white font-bold align-top p-8">Why Faculty <br class="hidden sm:inline"> and Staff Love <br
        class="hidden sm:inline"><!-- PLACEHOLDER --> {{this.loadeddata['Name']}}<!-- PLACEHOLDER --> <br
        class="hidden sm:inline"></h2>
  </div>

  <!-- Right Section -->
  <div class="md:w-1/2 lg:w-1/2 flex flex-col gap-6 text-white p-6 text-2xl">
    <div>
      <h3 class="text-4xl text-white font-bold">Plans Start at Just $16 a Month</h3>
      <p class="pt-4 pb-2">Affordable, transparent pricing with no hidden fees.</p>
    </div>
    <div class="border-t border-gray-300 pt-6">
      <h3 class="text-4xl text-white font-bold">On the T-Mobile 5G Network</h3>
      <p class="pt-4 pb-2">Seamless coverage with coast-to-coast 5G.</p>
    </div>
    <div class="border-t border-gray-300 pt-6">
      <h3 class="text-4xl text-white font-bold">Exclusive Game Day Perks</h3>
      <p class="pt-4 pb-2">VIP Perks, seat upgrades and premium giveaways.</p>
    </div>
    <div class="border-t border-gray-300 pt-6">
      <h3 class="text-4xl text-white font-bold">No Contracts, No Commitments</h3>
      <p class="pt-4 pb-2">Freedom to switch anytime.</p>
    </div>
  </div>
</div>